import { render, staticRenderFns } from "./StepItemContactType.vue?vue&type=template&id=401439ce&scoped=true&"
import script from "./StepItemContactType.vue?vue&type=script&lang=js&"
export * from "./StepItemContactType.vue?vue&type=script&lang=js&"
import style0 from "./StepItemContactType.vue?vue&type=style&index=0&id=401439ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401439ce",
  null
  
)

export default component.exports